// src/app/views/pages_pub/g5/rtPbG5.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const G5Land = Loadable(lazy(() => import("./G5Land")));
const G5Apply = Loadable(lazy(() => import("./G5Apply")));
const G5ApplyVeritas = Loadable(lazy(() => import("./G5ApplyVeritas")));
const G5ApplyPsatCamp = Loadable(lazy(() => import("./G5ApplyPsatCamp")));
const pathExt = getPathByCdExt(EXAM_TYPES.G5.rid_cd_ext);

const rtPbG5 = [
  { path: `/pub/${pathExt}/land/:rid_cd_ext/:rid_imp_sr`, element: <G5Land /> },
  { path: `/pub/${pathExt}/apply/:rid_cd_ext/:rid_imp_sr`, element: <G5Apply /> },
  { path: `/pub/${pathExt}/apply-veritas/:rid_cd_ext/:rid_imp_sr`, element: <G5ApplyVeritas /> },
  { path: `/pub/${pathExt}/app_psat_camp/:rid_cd_ext/:rid_imp_sr`, element: <G5ApplyPsatCamp /> }
];
export default rtPbG5;
